import { createApp } from '@backstage/frontend-defaults'
import catalogPlugin from '@backstage/plugin-catalog/alpha'
import { navModule } from './modules/nav'
import { homeModule } from './modules/home'
import { signInModule } from './modules/signIn'
import { dgCatalogModule } from './modules/dgCatalog'
import { fleetPlugin } from './modules/fleet'
import { graphModule } from './modules/graph'
import { themeModule } from './theme/themes'

export default createApp({
  features: [
    catalogPlugin,
    dgCatalogModule,
    navModule,
    homeModule,
    signInModule,
    fleetPlugin,
    graphModule,
    themeModule,
  ],
})
